// extracted by mini-css-extract-plugin
export default {"container":"NewTag__container___rGDAF"};